// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_fc821c', '__Inter_Fallback_fc821c'","fontStyle":"normal"},"className":"__className_fc821c","variable":"__variable_fc821c"};